import React, { useMemo } from 'react';
import { isNil } from 'lodash';

type MonetaryProps = {
  value: number | string;
  symbol?: boolean;
};

const formatBrazilianCurrency = (value: number | string): string => {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numericValue)) return '-';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(numericValue);
};

const formatBrazilianNumber = (value: number | string): string => {
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;

  if (isNaN(numericValue)) return '-';

  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(numericValue);
};

export default function Monetary({ value, symbol = false }: MonetaryProps) {
  const renderValue = useMemo(() => {
    if (isNil(value) || value === 0.0) return '-';

    return symbol
      ? formatBrazilianCurrency(value)
      : formatBrazilianNumber(value);
  }, [value, symbol]);

  return <span>{renderValue}</span>;
}
